export default "__VITE_ASSET__CKTUqck$__"